import {
  getIslandDefaultMapViewport,
  getIslandRegionOptions,
  regionMapping
} from 'alakai-aloha-shared'

const KAUAI_FALLBACK_VIEW = Object.freeze({
  center: Object.freeze({ lat: 22.0964, lng: -159.5261 }),
  zoom: Object.freeze({ mobile: 9.5, desktop: 10 })
})

export function getPhotoPlannerRegionOptions(island = 'kauai') {
  const regions = getIslandRegionOptions(island).map((option) => option.value)
  return [...new Set([...regions, 'Other'])]
}

export function getPhotoPlannerMapDefaults(island = 'kauai', viewportWidth = 1024) {
  const viewport = getIslandDefaultMapViewport(island) || KAUAI_FALLBACK_VIEW
  const mobile = Number(viewportWidth) < 640
  return {
    center: viewport.center,
    zoom: mobile ? viewport.zoom.mobile : viewport.zoom.desktop
  }
}

export function getPhotoSpotRegion(spot) {
  return spot?.region || regionMapping[spot?.area] || 'Other'
}
